<template>
  <component :is="tag" :id="id">
    <link-wrapper class="header-anchor" :href="`#${id}`">
      <link-anchor />
    </link-wrapper>
    <slot />
  </component>
</template>

<script setup lang="ts">
import LinkWrapper from '@/components/markdown/widgets/LinkWrapper.vue';
import LinkAnchor from '@/components/markdown/widgets/LinkAnchor.vue';

defineProps({
  tag: { type: String, required: true },
  id: { type: String, required: true },
});
</script>
<style scoped lang="scss">
h2 {
  font: var(--vvd-typography-heading-2);
}
h3 {
  font: var(--vvd-typography-heading-3);
}
</style>
